import AppSelectBox from 'components/FormElements/AppSelectBox';
import { FundTypeSelectorOption } from './FundTypeSelectorOptionsContext';

type Props = {
  options: Array<FundTypeSelectorOption>;
  value: Array<string>;
  allOptionsSelected: boolean;
  onChange: (values: Array<string>) => void;
};

const FundTypeSelector: React.FC<Props> = ({
  options,
  onChange,
  value,
  allOptionsSelected,
}) => {
  const getFundsSelected = (fundTypeDropdownValue: Array<string>) => {
    if (fundTypeDropdownValue.includes('all')) {
      if (!allOptionsSelected) {
        onChange(options.map((option) => option.key));
      } else {
        onChange([]);
      }
    } else {
      onChange(fundTypeDropdownValue);
    }
  };

  return (
    <AppSelectBox
      multiple
      fullWidth
      valueKey="key"
      labelKey="name"
      label="Fund type"
      variant="outlined"
      data={options ?? [{ name: 'All funds', key: 'all' }]}
      value={value}
      isCheckedAll={allOptionsSelected}
      onChange={(event) => {
        const valueToSet = Array.isArray(event.target.value)
          ? event.target.value
          : [event.target.value];
        getFundsSelected(valueToSet);
      }}
      renderValue={(selected: any) => {
        // avoids rendered value clash with label before data is fetched
        if (options.length === 0) return '';
        if (allOptionsSelected) {
          return 'All funds';
        } else if (selected.length === 1) {
          return options.find((label) => label.key === selected[0])?.name;
        } else if (selected.length > 1) {
          return `${
            options.find((label) => label.key === selected[0])?.name
          } +${selected.length - 1}`;
        }
      }}
    />
  );
};

export default FundTypeSelector;
